import { css } from 'goober';
import React, { memo } from 'react';
import colors from '../../styles/colors';
const Holder = css `
  display: block;
  width: 22px;
  height: 20px;
`;
const HeartIcon = ({ liked }) => {
    const fillColor = liked ? colors.glanceRed : colors.white;
    return (React.createElement("span", { className: Holder },
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "23", height: "20", viewBox: "0 0 23 20" },
            React.createElement("g", { fill: "none", fillRule: "evenodd" },
                React.createElement("g", { fill: fillColor, fillRule: "nonzero" },
                    React.createElement("g", null,
                        React.createElement("path", { d: "M16.18 0c-2.131 0-4.096 1.094-5.14 2.862C9.996 1.094 8.031 0 5.9 0 2.643 0 0 2.876 0 5.977 0 13.766 11.04 19.2 11.04 19.2s11.04-5.434 11.04-13.223c0-3.1-2.642-5.977-5.9-5.977z", transform: "translate(-80 -669) translate(80 669)" })))))));
};
const shouldNotReRender = (prevProps, nextProps) => {
    return prevProps.liked === nextProps.liked;
};
export default memo(HeartIcon, shouldNotReRender);
//# sourceMappingURL=index.js.map